export const env = {
  URL_IMG: process.env.REACT_APP_PROFILE_IMAGE,
  URL_BACK: process.env.REACT_APP_API_ENDPOINT,
  MANUALS: process.env.REACT_APP_MANUALS,
  CONTRACTS: process.env.REACT_APP_CONTRACTS,
}
